interface ContactInfo {
  email: string;
  firstName: string;
  lastName: string;
}

const BILLING_CONSTANTS = {
  DOMAINS: new Set(["brex.com", "bill.com", "billgo.com"]),
  EMAIL_TERMS: ["invoices", "billing", "finance", "accountspayable"],
  NAME_TERMS: [
    "accounts",
    "payable",
    "invoices",
    "billing",
    "accounting",
    "finance",
  ],
};

function isValidBillingDomain(email: string): boolean {
  const emailDomain = email.split("@")[1];
  return BILLING_CONSTANTS.DOMAINS.has(emailDomain);
}

function containsBillingTerms(text: string, terms: string[]): boolean {
  return terms.some((term) => text.includes(term.toLowerCase()));
}

/**
 * Determines if a contact is a billing contact based on their email and name.
 * @param {ContactInfo} contactInfo - The contact information to check
 * @returns {boolean} - True if the contact is a billing contact, false otherwise
 */
export function isBillingContact({
  email,
  firstName,
  lastName,
}: ContactInfo): boolean {
  if (!email || typeof email !== "string") {
    return false;
  }

  try {
    const standardizedEmail = email.toLowerCase().trim();
    const standardizedFullName = `${firstName.toLowerCase().trim() ?? ""} ${
      lastName.toLowerCase().trim() ?? ""
    }`.trim();

    if (isValidBillingDomain(standardizedEmail)) {
      return true;
    }

    if (standardizedEmail.startsWith("ap@")) {
      return true;
    }

    if (
      containsBillingTerms(standardizedEmail, BILLING_CONSTANTS.EMAIL_TERMS)
    ) {
      return true;
    }

    if (
      containsBillingTerms(standardizedFullName, BILLING_CONSTANTS.NAME_TERMS)
    ) {
      return true;
    }

    return false;
  } catch (error) {
    console.error("Error in isBillingContact:", error);

    return false;
  }
}
